import { Select } from 'antd';


const AmountFieldSelect = ({ value = null, onChange }) => {

    const handleChange = (val) => {
        onChange?.(val);
    };

    return (
        <Select
            showSearch
            placeholder="Izberi znesek"
            optionFilterProp="label"
            options={[
                {
                    'label': 'Znesek brez DDV',
                    'value': 'amount_no_tax'
                },
                {
                    'label': 'Znesek z DDV',
                    'value': 'amount'
                }
            ]}
            value={value}
            onChange={handleChange}
        />
    );
}

export default AmountFieldSelect;
